export default __webpack_public_path__ + "static/9-b6d4b3b924f5c4664450374e53a68a9f.png";